module.exports = __webpack_public_path__ + "img/TurningStool8.003f6f62.jpg";